import { render, staticRenderFns } from "./NpBase.vue?vue&type=template&id=d2ab4b3e&scoped=true"
import script from "./NpBase.vue?vue&type=script&lang=js"
export * from "./NpBase.vue?vue&type=script&lang=js"
import style0 from "./NpBase.vue?vue&type=style&index=0&id=d2ab4b3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ab4b3e",
  null
  
)

export default component.exports